export const MAPTIVE_TUTORIAL_YOUTUBE_ID = 'uAqGpBPws7E';
export const MAPTIVE_OVERVIEW_YOUTUBE_ID = 'f-B2Z49t-k4';
